<template class="full-height">
  <div class="member-container full-height">
    <!-- 編輯會員資料 -->
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogMemberFormVisible"
      :title="
        roleSettingObj.id ? `編輯${roleSettingObj.account}-${roleSettingObj.name}帳號` : '新增帳號'
      "
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-alert
            :closable="false"
            title="密碼為使用不可逆的加密演算法，所以密碼無法查詢。只能設定新密碼。"
            type="warning"
            effect="dark"
          >
          </el-alert>
        </div>
        <el-form
          :rules="rules"
          size="mini"
          ref="memberForm"
          :model="roleSettingObj"
          :label-width="formLabelWidth"
        >
          <el-form-item :label="'帳號'" prop="account">
            <el-input v-model="roleSettingObj.account"></el-input>
          </el-form-item>

          <el-form-item :label="'姓名'" prop="name">
            <el-input v-model="roleSettingObj.name"></el-input>
          </el-form-item>

          <el-form-item :label="'Mail'" prop="mail">
            <el-input v-model="roleSettingObj.mail"></el-input>
          </el-form-item>

          <el-form-item :label="'電話'" prop="mobile">
            <el-input v-model="roleSettingObj.mobile"></el-input>
          </el-form-item>

          <el-form-item :label="'生日'">
            <el-date-picker
              v-if="roleSettingObj.birthday"
              style="width: 100%"
              v-model="roleSettingObj.birthday"
              type="date"
              placeholder="請選擇領隊生日"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="狀態">
            <el-radio-group v-model="roleSettingObj.status">
              <el-radio :label="0">停用</el-radio>
              <el-radio :label="1">啟用</el-radio>
              <el-radio :label="2">黑名單</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="'密碼'" prop="pwd">
            <el-button
              style="margin-bottom: 5px"
              v-if="roleSettingObj.id"
              :type="showPwdInupt ? 'primary' : 'success'"
              size="mini"
              @click="showPwdInuptHandler"
              >{{ showPwdInupt ? '取消' : '更改密碼' }}</el-button
            >
            <el-input
              v-if="!roleSettingObj.id || showPwdInupt"
              v-model="roleSettingObj.pwd"
              show-password
            ></el-input>
            <i style="color: #ccc; font-size: 12px; margin: 5px"
              >密碼原則：密碼必須包含英文，數字及長度介於6-16之間。</i
            >
          </el-form-item>
        </el-form>
        <div></div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('memberForm')">確定</el-button>
        <el-button type="danger" @click="dialogMemberFormVisible = !dialogMemberFormVisible"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 角色設定 -->
    <el-dialog
      v-if="rolesList.length > 0"
      v-loading="listLoading"
      :visible.sync="dialogFormVisible"
      :title="roleSettingObj.account + '-' + roleSettingObj.name + '-' + '角色設定'"
    >
      <el-table :data="rolesList" border fit highlight-current-row style="width: 100%">
        <el-table-column :label="'選取'">
          <template slot-scope="scope">
            <el-checkbox v-model="rolesSelected" :label="scope.row.roleCode"> 選取 </el-checkbox>
          </template>
        </el-table-column>

        <el-table-column :label="'角色代碼'">
          <template slot-scope="scope"> {{ scope.row.roleCode }} </template>
        </el-table-column>

        <el-table-column :label="'角色名稱'">
          <template slot-scope="scope">
            {{ scope.row.roleName }}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveRoles">確定</el-button>
        <el-button type="danger" @click="dialogFormVisible = !dialogFormVisible">取消</el-button>
      </span>
    </el-dialog>
    <!-- 編輯簡介 -->
    <el-dialog
      :top="dialogTopMargin"
      v-loading="listLoading"
      :visible.sync="dialogIntroFormVisible"
      :title="roleSettingObj.id ? '編輯簡介' : '新增簡介'"
      @closed="onDialogClosed"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-alert
            :closable="false"
            title="此為向外公開的個人簡介資料"
            type="warning"
            effect="dark"
          >
          </el-alert>
        </div>
        <el-form
          :rules="introRules"
          size="mini"
          ref="introductionForm"
          :model="roleSettingObj"
          :label-width="formLabelWidth"
        >
          <el-form-item label="頭貼" :label-width="formLabelWidth">
            <div>
              <Upload
                ref="uploadRef"
                :accept="'.jpg,.jpeg,.png'"
                :payload="roleSettingObj"
                :limit-file-count="1"
                :limitText="'圖片尺寸:70x70，須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
                :data-obj="fileObj"
                :use-drag="false"
                :action="'ToursCombine/saveIntroAvatar'"
                :auto-upload="false"
                :show-file-list="true"
                :form-on-loading-parent="listLoading"
                :btn-txt="'上傳'"
                :before-file-list="
                  roleSettingObj.fileInfo && roleSettingObj.fileInfo.length
                    ? roleSettingObj.fileInfo[0].files
                    : []
                "
              />
            </div>
          </el-form-item>

          <el-form-item :label="'名稱'" prop="authorName">
            <el-input v-model="roleSettingObj.authorName" maxlength="50" show-word-limit></el-input>
          </el-form-item>

          <el-form-item :label="'簡介'" prop="introduction">
            <el-input
              type="textarea"
              v-model="roleSettingObj.introduction"
              :autosize="{ minRows: 4, maxRows: 4 }"
            ></el-input>
          </el-form-item>

          <el-form-item :label="'排序'" prop="sort">
            <el-input v-model="roleSettingObj.sort"></el-input>
          </el-form-item>

          <el-form-item
            v-for="(social, index) in roleSettingObj.socialLinkList"
            :label="'社群' + (index + 1)"
            :key="index"
            :prop="'social.' + index + '.id'"
          >
            <el-select v-model="social.socialType" placeholder="請選擇">
              <el-option
                v-for="item in socialLinkSelectList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input v-model="social.url" style="width: 50%"></el-input>
            <el-button @click.prevent="removeSocialLink(social)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addSocialLink">新增社群</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveIntroduction('introductionForm')">確定</el-button>
        <el-button type="danger" @click="onDialogClosed">取消</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0" class="full-height">
      <div style="padding-bottom: 0">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="搜尋">
            <el-input
              size="mini"
              v-model="listQuery.qry"
              placeholder="輸入帳號或姓名"
              @keyup.enter.native="handleFilter"
            />
          </el-form-item>

          <el-form-item>
            <el-button
              size="mini"
              class="filter-item"
              type="primary"
              icon="el-icon-search"
              @click="handleFilter"
            >
              搜尋
            </el-button>

            <el-button type="success" size="mini" @click="addData">建立</el-button>

            <!-- <el-button
              v-if="title == 'TCLeader'"
              type="danger"
              size="mini"
              @click="showReviewList"
              >人工審核【{{ manuallyCount }}】</el-button
            > -->
          </el-form-item>
        </el-form>
      </div>

      <div style="position: relative; height: 80%">
        <el-table
          :key="tableKey"
          v-loading="listLoading"
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          height="100%"
          @sort-change="sortChange"
        >
          <el-table-column :label="'ID'" prop="id" sortable="custom" align="center" width="80">
            <template slot-scope="{ row }">
              <span>{{ row.id }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'帳號'"
            prop="account"
            sortable="custom"
            align="left"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.account }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'姓名'" prop="name" sortable="custom" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="'mail'" prop="mail" align="center" width="130">
            <template slot-scope="{ row }">
              <span>{{ row.mail }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="'角色'"
            prop="roles"
            sortable="custom"
            align="center"
            width="130"
          >
            <template slot-scope="{ row }">
              <span>{{ row.roles.toString() }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
                scope.row.status == 0 ? '停用' : scope.row.status == 1 ? '啟用' : '黑名單'
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="email驗證" width="120">
            <template slot-scope="scope">
              <i
                v-if="scope.row.emailValidated == false"
                class="el-icon-circle-close"
                style="font-size: 28px; color: red"
              ></i>
              <i v-else class="el-icon-circle-check" style="font-size: 28px"></i>
            </template>
          </el-table-column>

          <el-table-column align="center" label="資格審核" width="150">
            <template v-if="checkLeaderRole(scope.row.roles)" slot-scope="scope">
              <i
                v-if="scope.row.manuallyValidated == false"
                class="el-icon-circle-close"
                style="font-size: 28px; color: red"
              ></i>
              <i v-else class="el-icon-circle-check" style="font-size: 28px"></i>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="primary"
                icon="el-icon-edit"
                @click="editData(scope.row)"
              >
                編輯資料
              </el-button>
            </template>
          </el-table-column>

          <el-table-column v-if="title == 'TC'" align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="warning"
                icon="el-icon-key"
                @click="showSelfRoles(scope.row)"
              >
                角色設定
              </el-button>
            </template>
          </el-table-column>

          <el-table-column align="center" :label="'操作'" width="200">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="success"
                icon="el-icon-edit"
                @click="editIntroductionInfo(scope.row)"
                :disabled="checkRole(scope.row.roles)"
              >
                編輯簡介
              </el-button>
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            :label="'刪除'"
            width="200"
            v-if="checkPermission(['ITA-DEV'])"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="filter-item"
                type="danger"
                icon="el-icon-delete"
                @click="deleteMember(scope.row)"
              >
                刪除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        style="padding-top: 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getTcMembers, saveRoles, deleteMember, getTcRoles, saveTcData } from '@/api/member'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // secondary package based on el-pagination
import Upload from '@/views/ita/components/fileUpload.vue'
import checkPermission from '@/utils/permission' // 权限判断函数
import { deepClone } from '@/utils'
import { nextTick } from 'process'
import { getIntroduction, getIntroductionTypeList, saveIntroduction } from '@/api/tcSetting'
var defaultFormData = {
  account: null,
  birthday: '1990-01-01',
  id: null,
  mobile: null,
  name: null,
  roles: [],
  status: 1,
}

var defaultIntroductionFormData = {
  id: null,
  authorName: '',
  introduction: '',
  sort: 99,
  socialLinkList: [],
  fileInfo: [],
}
export default {
  name: 'Member',
  components: { Pagination, Upload },
  directives: { waves },
  filters: {},
  props: {
    pageRoles: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    checkRole() {
      return function (value) {
        return (
          value.findIndex(x => {
            return (
              x == 'TC-TRAVEL-LEADER' ||
              x == 'TC-BLOGGER' ||
              x == 'TC-COMPANY' ||
              x == 'TC-MANUFACTURER' ||
              x == 'TC-YOUTUBER' ||
              x == 'TC-KNOWLEDGE'
            )
          }) == -1
        )
      }
    },
    checkLeaderRole() {
      return function (value) {
        return (
          value.findIndex(x => {
            return x == 'TC-TRAVEL-LEADER'
          }) !== -1
        )
      }
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (!checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])) {
        let re = new RegExp(/^(?=.*\d)(?=.*[a-z]).{6,16}$/)
        if (!this.roleSettingObj.id && (!value || value === '')) {
          callback(new Error('請輸入密碼'))
        } else if (value.length > 0 && !re.test(value) && process.env.NODE_ENV != 'development') {
          callback(new Error('密碼請依照密碼原則建立!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var validateMobile = (rule, value, callback) => {
      if (!checkPermission(['ITA-DEV', 'APP-ADMIN', 'ITA-ADMIN'])) {
        let re = new RegExp(/^09[0-9]{8}$/)
        if (value && value.length > 0 && !re.test(value)) {
          callback(new Error('手機號碼格式為:0911222333'))
        } else {
          callback()
        }
      } else {
        callback()
      }

      // if (!value || value === "") {
      //   callback(new Error("請輸入手機號碼"));
      // } else if (value.length > 0 && !re.test(value)) {
      //   callback(new Error("手機號碼格式為:0911222333"));
      // } else {
      //   callback();
      // }
    }
    var validateMail = (rule, value, callback) => {
      let re = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
      if (value && value.length > 0 && !re.test(value)) {
        callback(new Error('mail格式不正確'))
      } else {
        callback()
      }

      // if (!value || value === "") {
      //   callback(new Error("請輸入手機號碼"));
      // } else if (value.length > 0 && !re.test(value)) {
      //   callback(new Error("手機號碼格式為:0911222333"));
      // } else {
      //   callback();
      // }
    }
    return {
      rules: {
        pwd: [{ validator: validatePass, trigger: 'blur' }],
        account: [{ required: true, message: '請輸入帳號', trigger: 'blur' }],
        name: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        mobile: [{ validator: validateMobile, trigger: 'blur' }],
        mail: [{ validator: validateMail, trigger: 'blur' }],
      },
      introRules: {
        authorName: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        introduction: [{ required: true, message: '請輸入簡介', trigger: 'blur' }],
      },
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      showPwdInupt: false,
      funcName: '帳號管理',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      dialogMemberFormVisible: false,
      rolesSelected: [],
      roleSettingObj: {},
      rolesList: [],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        roles: this.pageRoles,
        page: 1,
        limit: 30,
        sort: '-cUpdateDT',
      },
      dialogFormVisible: false,
      dialogIntroFormVisible: false,
      socialLinkSelectList: [],
      selectedUser: null,
    }
  },
  async created() {
    await this.getIntroSelectType()
    this.getRoles()
    await this.getList()
  },
  methods: {
    // async getCount() {
    //   var result = await getManuallyCount();
    //   this.manuallyCount = result.data;
    // },
    async getIntroSelectType() {
      this.socialLinkSelectList = await getIntroductionTypeList()
    },
    async deleteMember(row) {
      let vm = this
      if (confirm(`確定刪除【${row.name}】使用者資訊?一但刪除連同旅客關聯檔也會一併刪除。\r\n`)) {
        vm.loadingHanlder(true)
        let resp = await deleteMember({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.loadingHanlder(false)
      }
    },
    showPwdInuptHandler() {
      this.showPwdInupt = !this.showPwdInupt
    },
    loadingHanlder(action) {
      let vm = this
      if (vm.listLoading != action) {
        vm.listLoading = action
      }
    },
    checkPermission,

    saveRoles() {
      const vm = this
      const payload = {
        account: this.roleSettingObj.account,
        roles: this.rolesSelected,
      }
      if (
        this.rolesSelected.indexOf('TC-USER') == -1 &&
        this.rolesSelected.indexOf('TC-TRAVEL-LEADER') == -1
      ) {
        this.$message.error('不可同時移除 TC-USER 或 TC-TRAVEL-LEADER 角色')
        return false
      }
      if (
        this.rolesSelected.indexOf('TC-USER') !== -1 &&
        this.rolesSelected.indexOf('TC-TRAVEL-LEADER') !== -1
      ) {
        this.$message.error('一般使用者與領隊角色只能二選一')
        return false
      }
      this.$confirm(
        `確定儲存【${this.roleSettingObj.account}-${this.roleSettingObj.name}】的角色設定?`,
        '權限設定',
        {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'confirmTitle',
        }
      )
        .then(async () => {
          this.loadingHanlder(true)

          saveRoles(payload).then(async response => {
            vm.dialogFormVisible = !vm.dialogFormVisible
            this.loadingHanlder(false)

            if (response.success) {
              const u = vm.list.filter(f => {
                return f.account == vm.roleSettingObj.account
              })[0]
              u.roles.splice(0, u.roles.length)
              vm.rolesSelected.forEach(f => {
                u.roles.push(f)
              })

              const userInfo = `${vm.roleSettingObj.account}-${vm.roleSettingObj.name}權限已設定`
              this.$notify({
                title: 'Success',
                dangerouslyUseHTMLString: true,
                message: `
            <div>User：${userInfo}</div>
          `,
                type: 'success',
              })
              await this.getList()
            }
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    addData(row) {
      let vm = this
      vm.roleSettingObj = JSON.parse(JSON.stringify(defaultFormData))
      vm.dialogMemberFormVisible = true
      nextTick(() => {
        this.$refs['memberForm'].clearValidate()
      })
    },
    editData(row) {
      let vm = this
      vm.roleSettingObj = row
      vm.dialogMemberFormVisible = true
    },
    saveData(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          var fromdata = deepClone(vm.roleSettingObj)
          if (fromdata.id == null && fromdata.pwd == undefined) {
            vm.$message({
              message: '請設定密碼',
              type: 'error',
            })
            return
          }
          this.loadingHanlder(true)
          fromdata.roles =
            fromdata.id !== null
              ? fromdata.roles
              : vm.title == 'TC'
                ? ['TC-USER']
                : ['TC-TRAVEL-LEADER']
          saveTcData(fromdata)
            .then(async response => {
              console.log(response)
              await vm.getList()
              vm.dialogMemberFormVisible = false
              this.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {
              this.loadingHanlder(false)
              console.log(error.data.message)
            })
        } else {
          return false
        }
      })
    },
    async editIntroductionInfo(row) {
      //透過api取得
      let vm = this
      vm.listLoading = true
      vm.selectedUser = row.id
      await getIntroduction(row.id)
        .then(response => {
          console.log(response)
          if (response.data == null) {
            vm.roleSettingObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
          } else {
            vm.roleSettingObj = JSON.parse(JSON.stringify(response.data))
          }
          vm.listLoading = false
          vm.dialogIntroFormVisible = true
        })
        .catch(error => {
          console.log(error)
        })
    },

    saveIntroduction(formName) {
      if (!confirm('確定儲存資料?')) {
        return
      }
      let vm = this
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.loadingHanlder(true)
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            alert('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          console.log(payload)
          payload.bindUser = vm.selectedUser
          await saveIntroduction(payload)
            .then(response => {
              //vm.dialogIntroFormVisible = false;
              vm.onDialogClosed()
              vm.loadingHanlder(false)
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            })
            .catch(error => {})
        }
      })
    },
    addSocialLink() {
      this.roleSettingObj.socialLinkList.push({
        id: null,
        socialType: 1,
        url: '',
      })
    },
    removeSocialLink(item) {
      var index = this.roleSettingObj.socialLinkList.indexOf(item)
      if (index !== -1) {
        this.roleSettingObj.socialLinkList.splice(index, 1)
      }
    },
    showSelfRoles(user) {
      const vm = this
      vm.dialogFormVisible = !vm.dialogFormVisible
      vm.roleSettingObj = user
      // empty array
      vm.rolesSelected = user.roles
      // vm.rolesSelected.splice(0, vm.rolesSelected.length);
      // vm.rolesList.forEach((f) => {
      //   const hasRole = user.roles.some((role) => role == f.roleCode);
      //   if (hasRole) {
      //     vm.rolesSelected.push(f.roleCode);
      //   }
      // });
    },
    getRoles() {
      // this.loadingHanlder(true);
      getTcRoles().then(response => {
        this.rolesList = response.data
        // this.loadingHanlder(false);
      })
    },
    async getList() {
      this.loadingHanlder(true)
      var res = await getTcMembers(this.listQuery)
      this.list = res.data.data
      this.total = res.data.total
      this.loadingHanlder(false)
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['introductionForm'].clearValidate()
      this.roleSettingObj = JSON.parse(JSON.stringify(defaultIntroductionFormData))
      this.dialogIntroFormVisible = false
    },

    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.status = status
    },
    handleRoleChange(value) {
      console.log(value)
    },
    sortChange(data) {
      const { prop, order } = data
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
  },
}
</script>
<style scope>
.full-height {
  position: relative;
  height: 100%;
}
</style>
